import React from 'react';
import {
  Container,
  Typography,
  Button,
  Box,
  Grid,
  Paper,
  Stack
} from '@mui/material';
import {
  Add as AddIcon,
  Work as WorkIcon,
  Business as BusinessIcon,
  ReceiptLong as ReceiptIcon,
} from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import CommunityGroupsCard from '../components/CommunityGroupsCard';
import QuickActionsGrid from '../components/dashboard/QuickActionsGrid';

const CompanyDashboard = () => {
  const navigate = useNavigate();

  const handleViewProfile = () => {
    navigate('/company/profile-management');
  };

  const handleSimplePostJob = () => {
    navigate('/company/post-job-simple');
  };

  const handleManageJobs = () => {
    navigate('/company/jobs');
  };

  const quickActions = [
    {
      key: 'post-new-job',
      title: 'Post new job',
      description: 'Launch a role in minutes with our guided form.',
      icon: AddIcon,
      accent: 'primary.main',
      actionLabel: 'Create posting',
      action: handleSimplePostJob
    },
    {
      key: 'community-groups',
      component: CommunityGroupsCard,
    },
    {
      key: 'invoices',
      title: 'Invoices',
      description: 'Create and manage your invoices.',
      icon: ReceiptIcon,
      accent: 'warning.main',
      iconColor: 'grey.900',
      actionLabel: 'Manage invoices',
      action: () => navigate('/invoice')
    },
    {
      key: 'manage-openings',
      title: 'Manage openings',
      description: 'Track status, edit listings, and review candidates.',
      icon: WorkIcon,
      accent: 'success.main',
      actionLabel: 'View jobs',
      action: handleManageJobs
    },
    {
      key: 'update-company-profile',
      title: 'Update company profile',
      description: 'Keep your brand story and benefits current.',
      icon: BusinessIcon,
      accent: 'secondary.main',
      actionLabel: 'Edit profile',
      action: handleViewProfile
    },
    
  ];

  return (
      <Container maxWidth="lg" sx={{ py: { xs: 3, md: 5 } }}>
        <Stack spacing={{ xs: 3, md: 4 }}>
          <Box mb={2} textAlign="center">
            <Typography variant="h5" fontWeight={600}>
              Quick actions
            </Typography>
            <Typography variant="body2" color="text.secondary">
              Keep your hiring pipeline sharp with these shortcuts.
            </Typography>
          </Box>

          <QuickActionsGrid cards={quickActions} context={{ navigate }} />
        </Stack>
      </Container>
  );
};

export default CompanyDashboard;